export default {
  contacts: [],
  contract: {},
  filters: {},
  paginationOptions: {}
};
